import theme from '@css/theme.style.json';
import { faQuestion } from '@fortawesome/pro-solid-svg-icons';

function formatCompanyAddress(company) {
  const {
    CRAB_STR,
    CRAB_HNR,
    CRAB_BNR,
    CRAB_PC,
    CRAB_GEM,
  } = company.properties;

  const parts = [];

  const streetPart = [];
  if (CRAB_STR) streetPart.push(CRAB_STR);
  if (CRAB_HNR) streetPart.push(CRAB_HNR);
  if (CRAB_BNR) streetPart.push(CRAB_BNR);

  if (streetPart.length) {
    parts.push(streetPart.join(' '));
  }

  const cityPart = [];
  if (CRAB_PC) cityPart.push(CRAB_PC);
  if (CRAB_GEM) cityPart.push(CRAB_GEM);

  if (cityPart.length) {
    parts.push(cityPart.join(' '));
  }

  return parts.join(', ');
}

function formatApplicationAddress(application) {
  const parts = [
    application.straat && application.huisnummer ? `${application.straat} ${application.huisnummer}` : application.straat || application.huisnummer,
    application.postcode && application.gemeente ? `${application.postcode} ${application.gemeente}` : application.postcode || application.gemeente,
    application.landCode ? (application.landCode !== 'BE' && application.landCode) : null,
  ];

  return parts.filter(Boolean).join(', ');
}

function getSelectedVacancy(vacancies, vdabReferentie) {
  if (!vacancies || !vdabReferentie) {
    return undefined;
  }

  return vacancies.find(v => v.properties?.vacatureReferentie?.vdabReferentie === vdabReferentie);
}

function getJobApplicationLocation(vacancy) {
  const sollicitatieAdres = vacancy?.properties?.sollicitatieprocedure?.sollicitatieAdres;
  if (!sollicitatieAdres?.straat) {
    return undefined;
  }

  return {
    lat: sollicitatieAdres.locatie.latitude,
    lng: sollicitatieAdres.locatie.longitude,
  };
}

const BASE_URL = 'https://www.google.com/maps/dir/?';

function getGoogleMapsTravelMode(transportMode) {
  switch (transportMode) {
    case 'walking':
      return 'walking';
    case 'bike':
      return 'bicycling';
    case 'ov':
      return 'transit';
    case 'car':
    default:
      return 'driving';
  }
}

function getGoogleMapsUrl(from, to, transportMode) {
  const origin = `${from.lat},${from.lng}`;
  const destination = `${to.lat},${to.lng}`;

  return `${BASE_URL}api=1&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}&travelmode=${getGoogleMapsTravelMode(transportMode)}`;
}

function getTransportModeLayout(mode, weightName, transportMode) {
  let type = transportMode !== 'e-bike' ? mode : 'E-BIKE';
  if (weightName === 'pedestrian') type = 'WALK';
  if (weightName === 'auto') type = 'CAR';

  switch (type) {
    case 'WALK':
      return {
        icon: '/img/icons/transport_types/walking.svg',
        name: 'Te voet',
        color: theme.color['transport-types'].walking,
      };
    case 'E-BIKE':
      return {
        icon: '/img/icons/transport_types/e-bike.svg',
        iconSize: '26px',
        name: 'E-Bike',
        color: theme.color['transport-types']['e-bike'],
      };
    case 'BICYCLE':
      return {
        icon: '/img/icons/transport_types/bike.svg',
        iconSize: '26px',
        name: 'Fiets',
        color: theme.color['transport-types'].bike,
      };
    case 'RAIL':
      return {
        icon: '/img/icons/train.svg',
        iconSize: '24px',
        name: 'Trein',
        color: theme.color['transport-types'].ov,
      };
    case 'BUS':
      return {
        icon: '/img/icons/bus.svg',
        iconSize: '22px',
        name: 'Bus',
        color: theme.color['transport-types'].ov,
      };
    case 'CAR':
      return {
        icon: '/img/icons/transport_types/car.svg',
        name: 'Auto',
        color: theme.color['transport-types'].car,
      };
    default:
      return {
        icon: faQuestion,
        name: mode,
        color: theme.color.common.grey.xlight,
      };
  }
}

function fitBounds(map, bounds, bottom, forPrint) {
  map.fitBounds(bounds, {
    padding: {
      top: 100,
      bottom: bottom + 50,
      left: 100,
      right: 100,
    },
    maxZoom: 20,
    ...(forPrint ? { duration: 0 } : {}),
  });
}

export {
  formatCompanyAddress,
  formatApplicationAddress,
  getJobApplicationLocation,
  getSelectedVacancy,
  getGoogleMapsUrl,
  getTransportModeLayout,
  fitBounds,
};